// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__vq9_9","actionsCol":"EnrolledClinics_actionsCol__2fe8f"};